import { create } from 'zustand'

/**
 * Poslední zobrazený seznam pohybů — detail z něj ví, kam vede „Předchozí /
 * Další“ a kam se vrátit, takže jde seznamem projít pohyb po pohybu.
 */
interface ListState {
  ids: string[]
  /** Query string seznamu (filtry), ať se zpátky vrátíme na stejný výběr. */
  search: string
  setList: (ids: string[], search: string) => void
}

export const useListStore = create<ListState>((set) => ({
  ids: [],
  search: '',
  setList: (ids, search) => set({ ids, search }),
}))
